import { Link } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function StorageCTABand() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="relative overflow-hidden bg-gradient-to-r from-secondary-700 via-secondary-600 to-brand-700">
      <div className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>
      <div ref={ref} className={`container-page relative z-10 py-16 md:py-20 text-center scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-paper-50 mb-3">
          List Your Facility on Freshhlock Storage
        </h2>
        <p className="text-secondary-200/80 max-w-lg mx-auto mb-8">
          Join 340+ warehouse partners already earning from their freezing capacity. Zero listing fees — we earn when you earn.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="px-8 py-3.5 bg-accent-500 hover:bg-accent-400 text-brand-800 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
          >
            List Your Facility
          </Link>
          <Link
            to="/contact"
            className="px-8 py-3.5 border-2 border-paper-50/30 hover:border-paper-50/60 text-paper-50 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
          >
            Talk to Our Storage Team
          </Link>
        </div>
      </div>
    </section>
  );
}